const STORAGE_KEY = "webprofit:onboarding-sound";
let audioContext = null;

function canUseAudio() {
  return typeof window !== "undefined" && Boolean(window.AudioContext || window.webkitAudioContext);
}

function getAudioContext() {
  if (!canUseAudio()) return null;
  if (!audioContext) {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    audioContext = new AudioContext();
  }
  if (audioContext.state === "suspended") {
    audioContext.resume().catch(() => null);
  }
  return audioContext;
}

export function isOnboardingSoundEnabled() {
  if (typeof window === "undefined") return true;
  try {
    return window.localStorage.getItem(STORAGE_KEY) !== "off";
  } catch {
    return true;
  }
}

export function setOnboardingSoundEnabled(enabled) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, enabled ? "on" : "off");
  } catch {
    // El onboarding sigue funcionando aunque el navegador bloquee localStorage.
  }
  if (enabled) getAudioContext();
}

function tone(context, { frequency, startsAt, duration, gain = 0.035, type = "sine" }) {
  const oscillator = context.createOscillator();
  const volume = context.createGain();
  oscillator.type = type;
  oscillator.frequency.setValueAtTime(frequency, startsAt);
  volume.gain.setValueAtTime(0.0001, startsAt);
  volume.gain.exponentialRampToValueAtTime(gain, startsAt + 0.015);
  volume.gain.exponentialRampToValueAtTime(0.0001, startsAt + duration);
  oscillator.connect(volume);
  volume.connect(context.destination);
  oscillator.start(startsAt);
  oscillator.stop(startsAt + duration + 0.02);
}

export function playOnboardingSound(kind = "start") {
  if (!isOnboardingSoundEnabled()) return;
  const context = getAudioContext();
  if (!context) return;

  const now = context.currentTime + 0.015;
  if (kind === "success") {
    tone(context, { frequency: 523.25, startsAt: now, duration: 0.18 });
    tone(context, { frequency: 659.25, startsAt: now + 0.12, duration: 0.22 });
    tone(context, { frequency: 783.99, startsAt: now + 0.24, duration: 0.28 });
    return;
  }

  tone(context, { frequency: 440, startsAt: now, duration: 0.12, gain: 0.025 });
  tone(context, { frequency: 587.33, startsAt: now + 0.08, duration: 0.18, gain: 0.03 });
}
